// @flow

export const PrefixTypes = {
    ID: 'ID',
    NUMERATION: 'NUMERATION',
    NONE: 'NONE'
};

export type PrefixType = $Keys<typeof PrefixTypes>;
